import { TFunction } from 'i18next';

import translations from 'services/translations/translations';

/**
 * The message for a save refused because another user saved after the page was loaded
 * (409), or null for other errors.
 */
const getConflictMessage = (error: any, t: TFunction): string | null => {
  const response = error?.response;
  if (response?.status !== 409) {
    return null;
  }

  const changedBy: string | null = response.data?.changedBy ?? null;
  const changedAt: string | null = response.data?.changedAt ?? null;
  const time =
    changedAt === null
      ? ''
      : new Date(
          // The server sends UTC without a zone
          changedAt.endsWith('Z') ? changedAt : `${changedAt}Z`
        ).toLocaleString('fi-FI', {
          day: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
          month: 'numeric',
        });

  return changedBy === null
    ? t(`${translations.offers}:concurrency.Changed by someone`)
    : t(`${translations.offers}:concurrency.Changed`, {
        name: changedBy,
        time,
      });
};

export default getConflictMessage;
